module.exports = __webpack_public_path__ + "static/media/Ex2-S0-SectionBreak.85c2504b.PNG";